import { render, staticRenderFns } from "./OverdueSuccess.vue?vue&type=template&id=fd7b7b68&"
import script from "./OverdueSuccess.vue?vue&type=script&lang=js&"
export * from "./OverdueSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports